import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesClientDetailMain } from './modules/ui/Main';

const ClientDetailPage = (
  <SuspensePage>
    <PagesClientDetailMain />
  </SuspensePage>
);

export default ClientDetailPage;
